import { create } from "zustand";
import { produce } from "immer";
import { StepConnectTransferTypeEnum } from "@features/StepsContent/components/StepConnect/StepConnectTransferTypeEnum";
import { FxIdWebFeaturesProfileGetResponse } from "@/api/gen";
import OpenApiClient from "@/api/OpenApiClient";

export interface ISocialIds {
	[FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierType: number]: string;
}
export interface IConnectStepStore {
	stepFinished: boolean;
	mygamesExternalId: string | null;
	transferType: StepConnectTransferTypeEnum;
	agreedToStartFromScratch: boolean;
	error: string | null;
	clearError: () => void;
	setTransferType: (newTransferType: string) => void;
	toogleAgreedToStartFromScratch: () => void;
	profiles: FxIdWebFeaturesProfileGetResponse | null;
	refreshProfiles: () => Promise<ISocialIds>;
	socialIds: ISocialIds;
}

function checkFinished(store: IConnectStepStore) {
	if (store.agreedToStartFromScratch && store.transferType === StepConnectTransferTypeEnum.StartFromScratch) {
		store.stepFinished = true;
	} else if (store.transferType === StepConnectTransferTypeEnum.TransferProgress && store.mygamesExternalId) {
		store.stepFinished = false;
	} else {
		store.stepFinished = false;
	}
	return store.stepFinished;
}

export const connectStepStore = create<IConnectStepStore>((set) => ({
	socialIds: {},
	profiles: null,
	refreshProfiles: async (): Promise<ISocialIds> => {
		const data = await OpenApiClient.Profile.fxIdWebFeaturesProfileGetEndpoint({});
		const socialIds: ISocialIds = {};

		for (let i = 0; i < data.SocialIdentifiers.length; i++) {
			const socId = data.SocialIdentifiers[i];
			socialIds[socId.Type] = socId.Id;
		}
		let result = {};

		set(
			produce((store: IConnectStepStore) => {
				store.profiles = data;
				store.socialIds = socialIds;
				result = store.socialIds;
			})
		);
		return result;
	},
	error: null,
	mygamesExternalId: null,
	stepFinished: false,
	transferType: StepConnectTransferTypeEnum.None,
	agreedToStartFromScratch: false,
	setTransferType: (newTransferType: string) => {
		set(
			produce((store: IConnectStepStore) => {
				store.transferType = newTransferType as StepConnectTransferTypeEnum;
				checkFinished(store);
			})
		);
	},
	toogleAgreedToStartFromScratch: () => {
		set(
			produce((store: IConnectStepStore) => {
				store.agreedToStartFromScratch = !store.agreedToStartFromScratch;
				checkFinished(store);
			})
		);
	},

	clearError: () => {
		set(
			produce((store: IConnectStepStore) => {
				store.error = null;
			})
		);
	}
}));
